import React, { useMemo } from 'react';

import { useTranslation } from '../../../../../../hooks';
import { datePadStart } from '../../../../../../helpers';

interface NextDropDateDigitProps {
  name: string;
  digit: number;
}

export const NextDropDateDigit: React.FC<NextDropDateDigitProps> = ({
  name,
  digit
}) => {

  const t = useTranslation();

  const digitFormated = useMemo(() => {
    return digit < 0 ? '00' : datePadStart(digit);
  }, [digit]);

  return (
    <div className="free-drop-live-data-items">
      <p className="free-drop-live-data-number">{digitFormated}</p>
      <p className="free-drop-live-data-text">{t(name)}</p>
    </div>
  );
};
